<template>
<div class="chapter">
<div class="inner_page">
<p class="block_" id="id_preface"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Carlos Kuhn is an accomplished philosopher, scientist, and writer with a passion for exploring the depths of human existence. With a background in mathematics and quantum physics, Carlos is a leading researcher in open-source technology, serving as the Research Chair on Open-Source Technology and an Associate Professor at the University of Canberra. His pioneering work focuses on quantum machine learning and cognitive AI, challenging traditional paradigms and inspiring profound insights into the nature of consciousness and reality. His work aims to inspire readers to ponder the mysteries of life and consciousness.</p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?383c27c8